import _classCallCheck from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import sdk from '@xpeng/js-bridge'; // 分享接口
var XPMotorsApi = /*#__PURE__*/function () {
  function XPMotorsApi() {
    _classCallCheck(this, XPMotorsApi);
  }
  _createClass(XPMotorsApi, null, [{
    key: "getSdk",
    value: function getSdk() {
      return sdk;
    }
    /**
     * 分享接口
     * @param params 分享接口参数
     */
  }, {
    key: "share",
    value: function share(params) {
      return sdk.callHandler('share', params);
    }
    /**
     * 获取AuthCode
     * @param params 获取AuthCode参数
     */
  }, {
    key: "getAuthCode",
    value: function getAuthCode(params) {
      return sdk.callHandler('getAuthCode', params);
    }
    /**
     * 首页滑至顶部
     */
  }, {
    key: "scrollHomePageToTop",
    value: function scrollHomePageToTop() {
      return sdk.callHandler('scrollHomePageToTop', {});
    }
    /**
     * 拉起支付客户端
     * @param params 拉起支付客户端参数
     */
  }, {
    key: "pay",
    value: function pay(params) {
      return sdk.callHandler('pay', params);
    }
    /**
     * 调起二维码扫描
     * @param params 调起二维码扫描参数
     */
  }, {
    key: "qrScan",
    value: function qrScan(params) {
      return sdk.callHandler('qrScan', params);
    }
    /**
     * 监听网页滚动
     * @param params 监听网页滚动参数
     */
  }, {
    key: "onPageScroll",
    value: function onPageScroll(params) {
      sdk.callHandler('onPageScroll', params);
    }
    /**
     * 通知打开图片浏览器
     * @param params 通知打开图片浏览器参数
     */
  }, {
    key: "isAlbumOpen",
    value: function isAlbumOpen(params) {
      sdk.callHandler('isAlbumOpen', params);
    }
    /**
     * 设定返回给上一层页面的操作结果
     * @param params 设定返回给上一层页面的操作结果参数
     */
  }, {
    key: "setResult",
    value: function setResult(params) {
      sdk.callHandler('setResult', params);
    }
    /**
     * 调起指定的微信小程序
     * @param params 调起指定的微信小程序参数
     */
  }, {
    key: "openWechatMiniProgram",
    value: function openWechatMiniProgram(params) {
      return sdk.callHandler('openWechatMiniProgram', params);
    }
    /**
     * 主动获取用户登录状态和用户信息
     */
  }, {
    key: "getLoginState",
    value: function getLoginState() {
      return sdk.callHandler('getLoginState', {});
    }
    /**
     * 新开窗口打开链接
     * @param params 新开窗口打开链接参数
     */
  }, {
    key: "openUrl",
    value: function openUrl(params) {
      sdk.callHandler('openUrl', params);
    }
    /**
     * 打开分享面板
     * @param params 打开分享面板参数
     */
  }, {
    key: "sharePanel",
    value: function sharePanel(params) {
      return sdk.callHandler('sharePanel', params);
    }
    /**
     * 发送网络请求接口
     * @param params 发送网络请求接口参数
     */
  }, {
    key: "request",
    value: function request(params) {
      return sdk.callHandler('request', params);
    }
    /**
     * 通知JS端，首页社区滑动
     * @param handler 通知JS端，首页社区滑动处理器
     */
  }, {
    key: "setFinishedScrollHomePageHandler",
    value: function setFinishedScrollHomePageHandler(handler) {
      if (typeof handler === 'object') {
        sdk.registerHandler('finishedScrollHomePage', function (options, responseCallback) {
          responseCallback(handler);
        });
      }
      if (typeof handler === 'function') {
        sdk.registerHandler('finishedScrollHomePage', function (options, responseCallback) {
          responseCallback(handler(options));
        });
      }
    }
    /**
     * 通知JS端，进行页面返回
     * @param handler 通知JS端，进行页面返回处理器
     */
  }, {
    key: "setGoBackHandler",
    value: function setGoBackHandler(handler) {
      if (handler === null) {
        sdk.registerHandler('goBack', function () {});
      }
      if (typeof handler === 'object') {
        sdk.registerHandler('goBack', function (options, responseCallback) {
          responseCallback(handler);
        });
      }
      if (typeof handler === 'function') {
        sdk.registerHandler('goBack', function (options, responseCallback) {
          responseCallback(handler(options));
        });
      }
    }
    /**
     * 关闭图片浏览器
     * @param handler 关闭图片浏览器处理器
     */
  }, {
    key: "setCloseAlbumHandler",
    value: function setCloseAlbumHandler(handler) {
      sdk.registerHandler('closeAlbum', function (options) {
        handler(options);
      });
    }
    /**
     * 接收来自上一层的操作结果
     * @param handler 接收来自上一层的操作结果处理器
     */
  }, {
    key: "setOnResultHandler",
    value: function setOnResultHandler(handler) {
      sdk.registerHandler('onResult', function (options) {
        handler(options);
      });
    }
    /**
     * 登录状态变化通知
     * @param handler 登录状态变化通知处理器
     */
  }, {
    key: "setLoginStateChange",
    value: function setLoginStateChange(handler) {
      sdk.registerHandler('loginStateChange', function (options) {
        handler(options);
      });
    }
    /**
     * 控制顶部栏样式
     * @param handler 控制顶部栏样式处理器
     */
  }, {
    key: "setOnActionButtonShowingHandler",
    value: function setOnActionButtonShowingHandler(handler) {
      if (typeof handler === 'object') {
        sdk.registerHandler('onActionButtonShowing', function (options, responseCallback) {
          responseCallback(handler);
        });
      }
      if (typeof handler === 'function') {
        sdk.registerHandler('onActionButtonShowing', function (options, responseCallback) {
          responseCallback(handler(options));
        });
      }
    }
  }]);
  return XPMotorsApi;
}();
export { XPMotorsApi as default };